// @flow

import { event } from "../../utils/events";

import {
    fetchBlogs as fetchBlogsService,
    fetchBlog as fetchBlogService,
    fetchBlogImages as fetchBlogImagesService
} from "../../rest/blogs-context";

export const CLEAR_BLOGS = "state.blogs.CLEAR_BLOGS";
export const FETCH_BLOGS_SUCCESS = "state.blogs.FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_ERROR = "state.blogs.FETCH_BLOGS_ERROR";
export const FETCH_BLOG_SUCCESS = "state.blogs.FETCH_BLOG_SUCCESS";
export const FETCH_BLOG_ERROR = "state.blogs.FETCH_BLOG_ERROR";
export const FETCH_BLOG_IMAGES_SUCCESS = "state.blogs.FETCH_BLOG_IMAGES_SUCCESS";
export const FETCH_BLOG_IMAGES_ERROR = "state.blogs.FETCH_BLOG_IMAGES_ERROR";
export const SHOW_BLOG = "state.blogs.SHOW_BLOG";
export const HIDE_BLOG = "state.blogs.HIDE_BLOG";
export const SHOW_PHOTO = "state.blogs.SHOW_PHOTO";
export const PREVIOUS_PHOTO = "state.blogs.PREVIOUS_PHOTO";
export const NEXT_PHOTO = "state.blogs.NEXT_PHOTO";
export const HIDE_PHOTO = "state.blogs.HIDE_PHOTO";
export const SEARCH = "state.blogs.SEARCH";
export const HIDE_DIALOG = "state.blogs.HIDE_DIALOG";

export const fetchBlogs = () => async dispatch => {
    try {
        dispatch({ type: CLEAR_BLOGS });
        const blogs = await fetchBlogsService();
        dispatch({ type: FETCH_BLOGS_SUCCESS, payload: blogs });
    } catch (e) {
        console.log(e);
        dispatch({ type: FETCH_BLOGS_ERROR, payload: e });
    }
};

export const fetchBlog = blogId => async dispatch => {
    try {
        const blogs = await fetchBlogService(blogId);
        dispatch({ type: FETCH_BLOG_SUCCESS, payload: blogs });
    } catch (e) {
        console.log(e);
        dispatch({ type: FETCH_BLOG_ERROR, payload: e });
    }
};

export const fetchBlogImages = blog => async dispatch => {
    try {
        const images = await fetchBlogImagesService(blog);
        dispatch({ type: FETCH_BLOG_IMAGES_SUCCESS, payload: { blogId: blog.id, images } });
    } catch (e) {
        console.log(e);
        dispatch({ type: FETCH_BLOG_IMAGES_ERROR, payload: e });
    }
};

export const showBlog = blog => async dispatch => {
    dispatch({ type: SHOW_BLOG, payload: blog });

    event({
        category: "Browse",
        action: "Show Blog",
        value: blog.id
    });
};

export const search = searchTerm => async dispatch => {
    dispatch({ type: SEARCH, payload: searchTerm });
};

export const hideBlog = () => async dispatch => {
    dispatch({ type: HIDE_BLOG });
};

export const showPhoto = payload => async dispatch => {
    dispatch({ type: SHOW_PHOTO, payload });
    event({
        category: "Browse",
        action: "Show Photo",
        value: payload.images[payload.index].id
    });
};

export const nextPhoto = () => async dispatch => {
    dispatch({ type: NEXT_PHOTO });
};

export const previousPhoto = () => async dispatch => {
    dispatch({ type: PREVIOUS_PHOTO });
};

export const hidePhoto = () => async dispatch => {
    dispatch({ type: HIDE_PHOTO });
};



// WEBPACK FOOTER //
// ./src/state/blogs/actions.js